import { fetcher } from "fetcher!sofe";

export function sendCode(uuid, methodId) {
  return fetcher(`/wg/mfa-send?uuid=${uuid}`, {
    method: "post",
    body: {
      uuid,
      method: methodId,
    },
    passThrough401: true,
  });
}

export function getMfaTypes(uuid) {
  return fetcher(`/wg/mfa-methods-creds?uuid=${uuid}`);
}

export function createMfaMethod(type, { value, utcTimestamp, limitedAccessSession }) {
  return fetcher("/wg/mfa-methods", {
    method: "post",
    body: {
      type,
      value,
      approved_sending_at: utcTimestamp,
    },
    headers: {
      "Limited-Access": limitedAccessSession,
    },
  });
}

export function sendSetupMfaCode(mfaMethodId, limitedAccessSession) {
  return fetcher(`/wg/mfa-methods/${mfaMethodId}/send`, {
    method: "post",
    headers: {
      "Limited-Access": limitedAccessSession,
    },
  });
}

export function verifySetupMfaCode(mfaMethodId, body, limitedAccessSession) {
  return fetcher(`/wg/mfa-methods/${mfaMethodId}/code-login`, {
    method: "post",
    body,
    headers: {
      "Limited-Access": limitedAccessSession,
    },
  });
}
